import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Image from 'next/image';
import { FC } from 'react';
import { H2 } from '../../components';
import { CarouselItemProps } from './Carousel';

const useStyles = makeStyles(theme => ({
  container: {
    width: 280,
    maxWidth: 280,
    minWidth: 280,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(2),
    borderRadius: theme.shape.borderRadius * 2,
    overflow: 'hidden',
    backgroundColor: '#fff',
    boxShadow: `0 1px 1px hsl(0deg 0% 0% / 0.075),
      0 2px 2px hsl(0deg 0% 0% / 0.075),
      0 4px 4px hsl(0deg 0% 0% / 0.075),
      0 8px 8px hsl(0deg 0% 0% / 0.075),
      0 16px 16px hsl(0deg 0% 0% / 0.075)`,
    display: 'flex',
    flexDirection: 'column'
  },
  imageWrapper: {
    position: 'relative',
    width: '100%',
    height: 180,
    backgroundColor: '#f5f5f5'
  },
  content: {
    padding: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
  },
  headerSpacing: {
    marginBottom: theme.spacing(1)
  },
  descriptionSpacing: {
    marginBottom: theme.spacing(2)
  }
}));

const CarouselItem: FC<CarouselItemProps> = ({
  carouselItemImage,
  carouselItemHeader,
  carouselItemDescriptionText
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      {carouselItemImage && carouselItemImage.url && (
        <Box className={classes.imageWrapper}>
          <Image
            src={carouselItemImage.url}
            alt={carouselItemHeader || 'Image'}
            layout="fill"
            objectFit="cover"
            objectPosition="center"
          />
        </Box>
      )}
      {(carouselItemHeader || carouselItemDescriptionText) && (
        <Box className={classes.content}>
          {carouselItemHeader && (
            <H2 typoStyle="sm" mb="sm" className={classes.headerSpacing}>
              {carouselItemHeader}
            </H2>
          )}
          {carouselItemDescriptionText && (
            <Box mb="sm">{carouselItemDescriptionText}</Box>
          )}
        </Box>
      )}
    </Box>
  );
};

export default CarouselItem;
